export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/sqlite.b3256f7.svg";